// Single owner of which login screen is visible: every transition goes
// through setCurrentView, so two screens can never be active at once.
export const LOGIN_VIEWS = {
  LOGIN: 'login',
  PHONE_ENROLLMENT: 'phoneEnrollment',
  SMS_CODE: 'smsCode',
  TOTP_ENROLLMENT: 'totpEnrollment',
  TOTP_CODE: 'totpCode',
  MFA_METHOD_CHOOSER: 'mfaMethodChooser',
  MFA_ENROLLMENT_CHOOSER: 'mfaEnrollmentChooser',
  SMS_SUCCESS: 'smsSuccess',
};
